<section class="agu-hero" [attr.data-accent]="Accent">
    <label class="agu-hero__eyebrow" [class.agu-hero__eyebrow--sr]="!Eyebrow" [for]="FieldId">{{ Eyebrow || Placeholder }}</label>

    <div class="agu-hero__box">
        <div class="agu-hero__field">
            <svg
                class="agu-hero__icon"
                width="19"
                height="19"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                stroke-width="2.3"
                stroke-linecap="round"
                aria-hidden="true"
            >
                <circle cx="10.5" cy="10.5" r="6.5" />
                <path d="M15.4 15.4 21 21" />
            </svg>
            <textarea
                #field
                class="agu-hero__input"
                rows="1"
                [id]="FieldId"
                [placeholder]="Placeholder"
                [value]="Query"
                [disabled]="Busy"
                (input)="OnQueryInput(field.value, field)"
                (keydown)="OnKeydown($event)"
            ></textarea>
            @if (Query) {
                <button type="button" class="agu-hero__clear agu-hit-24" aria-label="Clear search" (click)="ClearQuery()">✕</button>
            }
        </div>

        <div class="agu-hero__bar">
            <div class="agu-hero__bar-left">
                @if (AttachLabel) {
                    @if (!Attachment) {
                        <button type="button" class="agu-hero__attach-btn" (click)="OpenFilePicker()">
                            <svg
                                width="14"
                                height="14"
                                viewBox="0 0 24 24"
                                fill="none"
                                stroke="currentColor"
                                stroke-width="2.2"
                                stroke-linecap="round"
                                aria-hidden="true"
                            >
                                <circle cx="12" cy="12" r="9" />
                                <path d="M12 8.5v7M8.5 12h7" />
                            </svg>
                            <span>{{ AttachLabel }}</span>
                        </button>
                        <span class="agu-hero__attach-hint">{{ AttachHint }}</span>
                    } @else {
                        <span class="agu-hero__chip" [class.agu-hero__chip--failed]="Attachment.Status === 'failed'" [class.agu-hero__chip--cv]="!!AttachedLabel">
                            <!-- P/job-finder.html:1134 — `CV attached · {name} · Remove`, the check and label only when the host names the attachment. -->
                            @if (AttachedLabel) {
                                <svg class="agu-hero__chip-ok" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M5 12.5l4.5 4.5L19 7.5" /></svg>
                                <span class="agu-hero__chip-label">{{ AttachedLabel }}</span>
                            }
                            @if (Attachment.Status === 'uploading') {
                                <i class="fa-solid fa-spinner fa-spin" aria-hidden="true"></i>
                            } @else if (Attachment.Status === 'failed') {
                                <i class="fa-solid fa-triangle-exclamation" aria-hidden="true"></i>
                            }
                            <b class="agu-hero__chip-name">{{ Attachment.Name }}</b>
                            @if (Attachment.Status === 'failed' && Attachment.Error) {
                                <span class="agu-hero__chip-error">{{ Attachment.Error }}</span>
                            }
                            <button type="button" class="agu-hero__chip-remove" (click)="RemoveAttachment()">Remove</button>
                        </span>
                    }
                    <input
                        #fileInput
                        type="file"
                        class="agu-hero__file-input"
                        accept=".pdf,.docx,.txt"
                        [attr.aria-label]="AttachLabel"
                        (change)="OnFileChosen($event)"
                    />
                }
            </div>

            <!-- Applied (P/job-finder.html:1137, 1546-1551): "Results shown" with a check; the click is a no-op, so it stays enabled for the cursor and the accessible name. -->
            <button
                type="button"
                class="agu-hero__submit"
                [class.agu-hero__submit--applied]="SubmitState === 'applied'"
                [disabled]="!Applied && !CanSubmit"
                [attr.aria-label]="SubmitState === 'applied' ? 'Search applied, results shown below' : null"
                (click)="Submit()"
            >
                @if (SubmitState === 'busy') {
                    <!-- fa-spin, not a local keyframe: Angular scopes keyframes a
                         component declares, so a local one would silently require the
                         HOST to define it globally. Font Awesome's is already loaded. -->
                    <i class="fa-solid fa-spinner fa-spin" aria-hidden="true"></i>
                    <span>{{ BusyLabel }}</span>
                } @else if (SubmitState === 'applied') {
                    <svg class="agu-hero__ok" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M5 12.5l4.5 4.5L19 7.5" /></svg>
                    <span>Results shown</span>
                } @else {
                    <span>{{ SubmitLabel }}</span>
                    <!-- The phone's icon-only submit arrow (P/Member_Hub.html:598); the label above stays its accessible name. -->
                    <svg class="agu-hero__submit-arrow" width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M5 12h14M13 6l6 6-6 6" /></svg>
                }
            </button>
        </div>
    </div>

    <!-- A host that replaces the Try row (the Job Finder's career-path chips, PJ:1402-1405) projects its own row here; the default row is
         left out by passing no Suggestions. -->
    <ng-content select="[TryRow]" />

    @if (Suggestions.length > 0) {
        <div class="agu-hero__try"
        ><!-- The mockup writes `Try` as a bare text node in `.tryrow`
             (grants.html:441), inheriting the row's own 12.5px muted type — a
             wrapper here would be a class with no rule (review M-3). Written
             tight so the 8px `gap` is the only space before the first pill.
             -->Try@for (suggestion of Suggestions; track suggestion) {
            <button type="button" class="agu-hero__try-pill" (click)="SelectSuggestion(suggestion)">{{ suggestion }}</button>
            }</div>
    }
</section>
